const data = [
  {
    id: 1,
    image: require("../assets/images/Projects/art_gallery.png"),
    title: "Art Gallery",
    describe:
      "A website where artists can sell their products and customers can buy products. This website is built with MERN stack.",
    link: "https://github.com/codekesh/ArtGalleryFrontend.git",
  },
  {
    id: 2,
    image: require("../assets/images/Projects/RealTime.png"),
    title: "Real-Time Chat Applications",
    describe:
      "I make chat Applications which can chat and have a sound after recieving and sending message with help of expressjs and SocketIO.",
    link: "https://github.com/codekesh/Real-Time-Chat-Repo.git",
  },
  {
    id: 3,
    image: require("../assets/images/Projects/frontend_mentor.png"),
    title: "FrontendMentor",
    describe:
      "I make dozen of clones of responsive website mentioned on Frontend Mentor with the help of HTML, CSS, Bootstrap.",
    link: "https://www.frontendmentor.io/profile/codekesh",
  },
];

export default data;
